import { useEffect, useState } from "react";
import userSessionApi from "../api/userSessionApi";

export default function UserSessionPage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;

    setLoading(true);
    setError("");

    userSessionApi
      .getAll()
      .then((res) => {
        if (cancelled) return;
        // Accept either a bare array or { items: [...] } / { data: [...] }
        const payload = res?.data;
        const items = Array.isArray(payload)
          ? payload
          : Array.isArray(payload?.items)
          ? payload.items
          : Array.isArray(payload?.data)
          ? payload.data
          : [];
        setData(items);
      })
      .catch((err) => {
        if (cancelled) return;
        const message =
          err?.response?.data?.message ||
          err?.message ||
          "Failed to load sessions.";
        setError(message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) return <div><h2>User Sessions</h2><p>Loading...</p></div>;
  if (error) return <div><h2>User Sessions</h2><p style={{ color: "crimson" }}>{error}</p></div>;
  if (data.length === 0) return <div><h2>User Sessions</h2><p>No sessions found.</p></div>;

  return (
    <div>
      <h2>User Sessions</h2>
      <ul>
        {data.map((item) => (
          <li key={item.id}>
            {item.userId} — {item.sessionStart}
          </li>
        ))}
      </ul>
    </div>
  );
}